var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"footerTipsNode",staticClass:"list-footer-tips"},[(_vm.more)?[_c('span',[_vm._v(_vm._s(_vm.$t('enterprise.effort-loading')))]),_c('svg',{staticClass:"more-style animation-rotate",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-mokuaijiazai"}})])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }